import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Customer } from "../customers/customer";
import { DeliveryAddress } from "../customers/delivery-address";
import { Order } from "../orders/order";
import {
  DeliveryNoteItem,
  IAddDeliveryNoteItem,
  IUpdateDeliveryNoteItem,
} from "./delivery-note-item";

export const DeliveryNote = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      date: types.maybeNull(types.string),
      purchaseOrderId: types.maybeNull(types.string),
      purchaseOrder: types.maybeNull(Order),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      number: types.maybeNull(types.string),
      man: types.maybeNull(types.string),
      licensePalate: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      deliveryAddressId: types.maybeNull(types.string),
      deliveryAddress: types.maybeNull(DeliveryAddress),
      items: types.optional(types.array(DeliveryNoteItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IDeliveryNote extends Instance<typeof DeliveryNote> {}
export interface IDeliveryNoteProperties
  extends SnapshotIn<typeof DeliveryNote> {}
export interface IAddDeliveryNote
  extends Pick<
    IDeliveryNoteProperties,
    | "date"
    | "number"
    | "note"
    | "licensePalate"
    | "man"
    | "purchaseOrderId"
    | "customerId"
    | "deliveryAddressId"
  > {
  items: IAddDeliveryNoteItem[];
}

export interface IUpdateDeliveryNote
  extends Pick<
    IDeliveryNoteProperties,
    | "id"
    | "date"
    | "number"
    | "note"
    | "licensePalate"
    | "man"
    | "purchaseOrderId"
    | "customerId"
    | "deliveryAddressId"
  > {
  items: IUpdateDeliveryNoteItem[];
}
